import { HistogramCanvasLayout } from './HistogramCanvasLayout.js';
import { HistogramChartGridLayout } from './HistogramChartGridLayout.js';
import { HistogramGridZeroLine } from './HistogramGridZeroLine.js';
import { HistogramChartOverlaysBorder } from '../overlays/HistogramOverlaysBorder.js';

export const HistogramChartPlot = () => (
  <>
    <HistogramChartGridLayout />
    <HistogramCanvasLayout />
    <HistogramGridZeroLine />
    <HistogramChartOverlaysBorder />
  </>
);

HistogramChartPlot['displayName'] = 'HistogramChartPlot';
